import React from 'react';
import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';
import { HeaderText } from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';

export type LayoutProcessingErcSubscriptionProps = {
  t: TypeAccountERCTranslations;
};

function LayoutProcessingErcSubscription({
  t,
}: LayoutProcessingErcSubscriptionProps) {
  return (
    <div data-testid="layoutProcessingErcSubscription" className="px-6 xl:px-0">
      <HeaderText
        text={t.subscriptionProcessingHeader}
        classes="mb-4 md:mb-6"
        size={HeaderSize.H1}
      />
      <p className="rounded-md p-6 md:p-8 shadow-[0px_4px_8px_0px_rgba(0,0,0,0.16)]">
        {t.subscriptionProcessingMessage}
      </p>
    </div>
  );
}

export default LayoutProcessingErcSubscription;
